//if need unix timestamp divide by 1000

import { between } from '@iotv/core-services'
import { isNonNaNNumber, Milliseconds } from '@iotv/iotv-v3-types'

/*
Unlikely this is a good idea back end without tz handling
*/

//timestamp for midnight
export const midnight = (): number => {
  const dayStart = new Date()
  return dayStart.setHours(0, 0, 0, 0)
}

//timestamp for now
export const now = (): number => {
  return Date.now()
}

//24, current hour
export const hour = (): number => {
  return new Date().getHours()
}

export const onTheHour = (hour: number) => {
  const time = new Date()
  return time.setHours(hour, 0, 0, 0)
}

export const getMonday = (d: number) => {
  const date = new Date(d)
  var day = date.getDay(),
    diff = date.getDate() - day + (day == 0 ? -6 : 1) // adjust when day is sunday
  return new Date(date.setDate(diff)).valueOf()
}

/** Should manually adjust for non-UTC times */
// NZ = +12 hours
export const isUTCTimestampInLeapYear = (timestamp: number) => {
  const year = new Date(timestamp).getFullYear()
  return year % 4 == 0 && year % 100 != 0 && year % 400 != 0
}

export const getReasonableValueNumber = (lo: number, hi: number) => (val: any) => {
  return isNonNaNNumber(val) && between(val, lo, hi)
}

/** returns true if in provided in ms is within reasonable range */
export const getReasonableTimestampMsFilter = (yearsBeforeNow: number, yearsAfterNow: number) => (x: any) => {
  let valid = false
  if (isNonNaNNumber(x)) {
    const loDate = new Date()
    loDate.setUTCFullYear(loDate.getUTCFullYear() - yearsBeforeNow)
    const hiDate = new Date()
    hiDate.setUTCFullYear(hiDate.getUTCFullYear() + yearsAfterNow)

    valid = between(x, loDate.valueOf(), hiDate.valueOf())
  }
  return valid
}

/** returns true if in provided in SECONDS is within reasonable range */
export const getReasonableTimestampSecondsFilter = (yearsBeforeNow: number, yearsAfterNow: number) => (x: any) => {
  let valid = false
  if (isNonNaNNumber(x)) {
    const loDate = new Date()
    loDate.setUTCFullYear(loDate.getUTCFullYear() - yearsBeforeNow)
    const hiDate = new Date()
    hiDate.setUTCFullYear(hiDate.getUTCFullYear() + yearsAfterNow)

    valid = between(x * Milliseconds.SECOND, loDate.valueOf(), hiDate.valueOf())
  }
  return valid
}
